/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Box from "components/generals/Box";
import useSort from "hooks/useSort.hook";
import TemplateTable from "components/tables/TemplateTable";
import { useState } from "react";
import TemplateRecycleBinModal from "components/views/TemplateRecycleBinModal";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { TemplateInterface, QueryResultInterface } from "@malmur-technologies/medicalsystem-shared";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Content component for displaying and managing HPI (History of Present Illness) templates.
 * Provides a table view of all templates with search, filtering, and pagination functionality.
 * @returns {React.ReactElement} The template data content component
 */
const TemplateDataContent: React.FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [templateList, setTemplateList] = useState<TemplateInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const { t } = useTranslation();
  const [filterModel, setFilterModel] = useState<string>("");
  const { sortBy, sortOrder, handleSortChange, buildSortParam } = useSort();

  useEffect(() => {
    const nameParam = filterModel ? `title=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.HPI_TEMPLATE_GET_ALL}?${nameParam}${buildSortParam()}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetTemplateHandler, "GET");
  }, [page, pageSize, filterModel, buildSortParam]);

  const onGetTemplateHandler = (templatesResponse: QueryResultInterface<TemplateInterface>) => {
    setTemplateList(templatesResponse.results);
    setRowsTotal(templatesResponse.total);
    setPageTotal(Math.ceil(templatesResponse.total / pageSize));
  };

  const [openRecycleModal, setOpenRecycleModal] = useState(false);

  const handleTemplateRestored = () => {
    const nameParam = filterModel ? `title=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.HPI_TEMPLATE_GET_ALL}?${nameParam}page=${page}&pageSize=${pageSize}`;
    sendRequest(url, onGetTemplateHandler, "GET");
  };

  return (
    <Box>
      <TemplateTable
        modelList={templateList}
        setModelList={setTemplateList}
        canSearchPlaceholder={t("templatesDataContent.searchTemplate")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
        onOpenRecycleBin={() => setOpenRecycleModal(true)}
        onSortChange={handleSortChange}
        currentSortBy={sortBy}
        currentSortOrder={sortOrder}
      />
      <TemplateRecycleBinModal
        open={openRecycleModal}
        onClose={() => setOpenRecycleModal(false)}
        onTemplateRestored={handleTemplateRestored}
      />
    </Box>
  );
};

export default TemplateDataContent;
